import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddressInfoBlock, OrderAttributesInfo } from "@jti/ui";
import OrderDotContent from "./OrderDotContent";
const OrderAddresses = ({ address, title, className, orderAttributesInfos }) => {
    const { name: companyName } = address?.pickupInformation || {};
    return (_jsxs(OrderDotContent, { condition: !!address, title: title, className: className, children: [_jsx(AddressInfoBlock, { companyName: companyName, address: address, hideTelephone: true, isEditable: true, hideName: !!companyName }), orderAttributesInfos && _jsx(OrderAttributesInfo, { orderAttributesInfos: orderAttributesInfos })] }));
};
export default OrderAddresses;
//# sourceMappingURL=OrderAddress.js.map